import { NgModule } from '@angular/core';
import { EyeWatchBootstrapModule } from './eyewatch-bootstrap.module';
import { RouteService } from '@kaiser-software/chassis-core';
import { AccountDashboardComponent } from './dashboards/pages/account/account.component';
import { AdminDashboardComponent } from './dashboards/pages/admin/admin.component';
import { ObservationsIndexComponent } from './observations/pages/observations/index/index.component';
import { ObservationsEditComponent } from './observations/pages/observations/edit/edit.component';
import { ObservationsCreateComponent } from './observations/pages/observations/create/create.component';
import { CategoriesIndexComponent } from './observations/pages/categories/index/index.component';
import { CategoriesCreateComponent } from './observations/pages/categories/create/create.component';
import { CategoriesEditComponent } from './observations/pages/categories/edit/edit.component';
import { DashboardComponent } from './dashboards/pages/dashboard/dashboard.component';
import { WorkLogsIndexComponent } from './work-logs/pages/work-logs/index/index.component';

@NgModule({
    imports: [
        EyeWatchBootstrapModule
    ],
})
export class EyeWatchRoutingModule {

    constructor(protected router: RouteService) {
        router.delete('home');
        router.add('', DashboardComponent, 'home');

        // Account dashboard
        router.add('accounts/:id/dashboard', AccountDashboardComponent, 'dashboard.account', {
            permission: 'account_dashboard.read'
        });

        // Admin dashboard
        router.add('admin', AdminDashboardComponent, 'dashboard.admin', {
            permission: 'admin_dashboard.read'
        });

        router.add('observations', ObservationsIndexComponent, 'observations.index');
        router.add('observations/create', ObservationsCreateComponent, 'observations.create');
        router.add('observations/:observation', ObservationsEditComponent, 'observations.edit');

        router.add('observation_categories', CategoriesIndexComponent, 'observation-categories.index');
        router.add('observation_categories/create', CategoriesCreateComponent, 'observation-categories.create');
        router.add('observation_categories/:category', CategoriesEditComponent, 'observation-categories.edit');

        router.add('observation_categories/:category/observation_categories/create', CategoriesCreateComponent, 'observation-categories-sub-observation-observation_categories.create');

        router.add('work-logs', WorkLogsIndexComponent, 'work-logs.index', {
            permission: 'work_log.read'
        });

        router.apply();
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/eyewatch-routing.module.ts